'use client';

import BaseModal from 'components/shared/BaseModal/BaseModal';
import EmailCapture from 'components/shared/EmailCapture/EmailCapture';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { getEnrollmentUrl } from 'utils/linkHelpers';
import { cn, getColorway } from 'utils/styles';
import type { HeroBentoCardSharedProps, HeroBentoCtaProps } from './types';

type Props = HeroBentoCtaProps & HeroBentoCardSharedProps;

const HeroBentoCta = ({ sys, copy, cta, disclaimers, disclaimerModal, cardColorway }: Props) => {
  const baseEnrollmentUrl = cta?.url || getEnrollmentUrl();
  const buttonText = cta?.text || 'Get started';

  return (
    <div
      className={cn('flex flex-col gap-4 rounded-3xl px-6 py-8 md:h-[454px]', getColorway(cardColorway))}
      data-testid="hero-bento-cta">
      {copy && (
        <div className="font-sans text-label-saans" {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextCopy copy={copy} ySpacing="none" />
        </div>
      )}
      <div className="mt-auto flex flex-col gap-4" {...liveUpdateAttrs(sys?.id, 'cta')}>
        <EmailCapture
          sys={sys}
          buttonText={buttonText}
          baseEnrollmentUrl={baseEnrollmentUrl}
          formClassName="md:flex-col md:items-stretch"
          buttonClassName="md:max-w-full bg-inverse text-content-inverse"
          buttonLiveUpdate={{ entryId: cta?.sys?.id, fieldId: 'text' }}
        />
        {disclaimers && (
          <div className="font-sans text-legal" {...liveUpdateAttrs(sys?.id, 'disclaimers')}>
            <RichTextCopy copy={disclaimers} ySpacing="none" inline />
            {disclaimerModal && (
              <BaseModal
                sys={disclaimerModal.sys}
                title={disclaimerModal.headline}
                body={disclaimerModal.copy}
                openButtonText={disclaimerModal.disclaimerText}
                iconPosition={disclaimerModal.iconPosition ?? 'after'}
                iconOnlyLink
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroBentoCta;
